import styled from 'styled-components';

export const BoxContainer = {
    RootContainer: styled.div`
        padding: 10px;
    `,
    ItemBox: styled.div`
        margin-bottom: 10px;
        border: 1px solid #f0f0f0;
        padding: 10px;
        border-radius: 5px;
        .firstFlex{
            display: flex;
            align-items: center;
            gap: 10px;

            .palletNumber{
                font-size: 20px;
                font-weight: 700;
                border: 1px solid black;
                width: 35px;
                height: 35px;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .itemName{
                font-size: 12px;
            }

            .boxQunatity{
                font-size: 12px;
            }
        }
    `,
}
export const TableContainer = {
    FlexWrapper:styled.div`
        display: flex;
    `,
    Container:styled.div`
        height: 300px;
        overflow: auto;
    `,
}